import * as React from "react";
import StoreGroupFinderContainerV2 from "../../../../components/StoreGroupFinderV2/components/StoreGroupFinderV2/StoreGroupFinderContainerV2.js";
import { StoreFinderProvider } from "../../../../context/StoreFinder/context/StoreFinder/provider.js";
const StoreGroupRoot = ({
  groupName,
  hideEmail,
  hidePhone,
  stores,
  storeFilters,
  urls
}) => {
  return /* @__PURE__ */ React.createElement(
    StoreFinderProvider,
    {
      googleMapsId: "google-maps-container",
      withUrlParams: true,
      hidePhone,
      hideEmail,
      initialStores: stores ?? void 0,
      isStoreFiltersButtonEnabled: true,
      urls
    },
    /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `),
    /* @__PURE__ */ React.createElement(StoreGroupFinderContainerV2, { groupName, storeFilters, urls })
  );
};
export {
  StoreGroupRoot as default
};
//# sourceMappingURL=StoreGroupRootV2.js.map
